export default __webpack_public_path__ + "static/media/send-money.46e79afa.svg";